<script setup lang="ts">
defineProps<{
  modelValue: number[];
  required: boolean;
  items: { value: number; title: string }[];
  hint: string;
  errorMessage: string | null;
}>();

const emit = defineEmits<{
  (e: 'update:modelValue', value: number[]): void;
}>();
</script>
<template>
  <v-autocomplete
    :model-value="modelValue"
    :items="items"
    :label="required ? 'Grupos' : 'Grupos (opcional)'"
    multiple
    chips
    closable-chips
    variant="outlined"
    class="mt-4"
    :error-messages="errorMessage"
    :hint="hint"
    persistent-hint
    @update:model-value="emit('update:modelValue', $event)"
  />
</template>
